import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { FC } from "react";
import LinkRemindForm from "./LinkRemindForm";
import LinkSignUpForm from "./LinkSignUpForm";
import OauthButton from "./OauthButton";
import OauthHeader from "./OauthHeader";

export interface IFormSignInState {
  email: string,
  password: string,
}

const FormSignIn: FC<{
  state: IFormSignInState,
  stateErr: Partial<IFormSignInState>,
  setState: (key: keyof IFormSignInState, value: string) => unknown,
  onHandler: () => unknown,
}> = ({
  state,
  stateErr,
  setState,
  onHandler,
}) => (
  <>
    <OauthHeader>
      Sign in
    </OauthHeader>
    <Box sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        label="Email Address"
        autoComplete="email"
        value={state.email}
        onChange={(e) => setState('email', e?.target?.value)}
        error={!!stateErr?.email}
        helperText={stateErr?.email ?? ''}
        autoFocus
      />
      <TextField
        margin="normal"
        required
        fullWidth
        label="Password"
        type="password"
        id="password"
        value={state.password}
        onChange={(e) => setState('password', e?.target?.value)}
        error={!!stateErr?.password}
        helperText={stateErr?.password ?? ''}
        autoComplete="current-password"
      />
      <Grid container>
        <Grid item xs>
          <LinkRemindForm />
        </Grid>
        <Grid item>
          <LinkSignUpForm />
        </Grid>
      </Grid>
      <OauthButton onClick={onHandler}>
        Sign In
      </OauthButton>      
    </Box>          
  </>
);

export default FormSignIn;
